import { ArrowDown, ArrowUpRight } from "lucide-react";
import { HERO_BG } from "../data/site";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-end overflow-hidden noise"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Industrijska elektroinstalacija"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black" />
        <div className="absolute inset-0 bg-grid bg-grid-fade opacity-50" />
      </div>

      {/* Top label */}
      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-8 pt-32 md:pt-40">
        <div className="flex items-center gap-3 mb-8 reveal">
          <span className="relative w-2 h-2 bg-brand pulse-red" />
          <span
            className="text-xs uppercase tracking-widest2 text-ink-muted"
            data-testid="hero-eyebrow"
          >
            Varaždin · Hrvatska · Obitelj Jalšovec
          </span>
        </div>

        <h1
          data-testid="hero-title"
          className="reveal font-display font-black text-white tracking-tightest leading-[0.88] text-[clamp(2.75rem,9vw,8.5rem)]"
        >
          Tradicija
          <br />
          <span className="text-glow text-brand">struje od</span>
          <br />
          1950.
        </h1>
        <div
          className="reveal mt-6 md:mt-8 max-w-md font-sans text-ink-muted text-xs md:text-sm uppercase tracking-widest2 border-l border-brand pl-4"
          data-testid="hero-subline"
        >
          Elektroinstalateri za poslovne, stambene i komercijalne objekte
        </div>

        <div className="mt-10 md:mt-14 grid md:grid-cols-12 gap-8 items-end pb-14 md:pb-24 reveal">
          <p className="md:col-span-5 text-ink-muted text-base md:text-lg leading-relaxed font-light">
            Električne instalacije, izrada razdjelnika, solarne elektrane,
            vatrodojava, gromobrani i još mnogo više — sve iz jedne stručne
            ekipe.
          </p>

          <div className="md:col-span-7 flex flex-wrap gap-4 md:justify-end">
            <a
              href="#kontakt"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-3 bg-brand hover:bg-brand-light text-white px-7 py-4 text-sm font-bold uppercase tracking-widest2 transition-all hover:shadow-[0_0_40px_rgba(220,38,38,0.55)]"
            >
              Zatražite ponudu
              <ArrowUpRight size={18} className="slide-arrow" />
            </a>
            <a
              href="#projekti"
              data-testid="hero-cta-secondary"
              className="group inline-flex items-center gap-3 border border-white/20 hover:border-white text-white px-7 py-4 text-sm font-bold uppercase tracking-widest2 transition-colors"
            >
              Naši projekti
              <ArrowUpRight size={18} className="slide-arrow" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom marquee */}
      <div className="relative z-10 border-y border-white/10 bg-black/70 backdrop-blur-sm overflow-hidden">
        <div className="marquee-track flex whitespace-nowrap py-4 w-max">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center">
              {[
                "Elektroinstalacije",
                "Solarne elektrane",
                "Vatrodojava",
                "Gromobranske instalacije",
                "DALI rasvjeta",
                "Punionice za EV",
                "Razdjelnici",
                "Komunikacijske instalacije",
                "Podno grijanje",
              ].map((t, j) => (
                <span
                  key={`${i}-${j}`}
                  className="font-display font-black tracking-tightest text-2xl md:text-3xl px-8 text-white/80"
                >
                  {t}
                  <span className="text-brand ml-8">/</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#o-nama"
        data-testid="hero-scroll-indicator"
        aria-label="Listaj dolje"
        className="absolute right-6 lg:right-8 bottom-28 md:bottom-32 z-10 hidden md:flex flex-col items-center gap-3 text-ink-muted hover:text-brand transition-colors"
      >
        <span className="text-[10px] tracking-widest2 uppercase rotate-90 origin-center mt-8">
          Scroll
        </span>
        <ArrowDown size={16} />
      </a>
    </section>
  );
}
